import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import axios from "axios";
import {
    Container,
    Box,
    Typography,
    TextField,
    Button,
} from "@material-ui/core";
import Logo from "../components/Logo/LogoKP.jsx";
import api from "../config/api";
import { vars } from "../config/theme";
import { MATERIAL_UI_PROPS } from "../lib/data";

const Unauthorized = (props) => {
    const [form, updateForm] = useState({
        name: "",
        password: "",
    });

    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    //try to sign in using cookie
    useEffect(() => login(new Event("autoLogin"), true), []);

    const handleError = (error) => {
        setLoading(false);
        const msg = error && error.response && error.response.data.message;
        setError(msg);
    };

    const login = (e, auto = false) => {
        e.preventDefault();
        setLoading(true);
        axios
            .post(`${api.baseUrl}/login`, { ...form })
            .then((response) => {
                setLoading(false);
                if (response.status == 200) {
                    return props.setUser(response.data);
                }
            })
            .catch((response) => {
                handleError(!auto && response);
            });
    };

    const handleFormChange = (event) => {
        const paramName = event.target.name;
        const value = event.target.value;

        const newFormValue = { ...form };

        newFormValue[paramName] = value;

        updateForm(newFormValue);
    };

    return (
        <Container maxWidth="xs">
            {/*<Logo />*/}
            <Typography component="p">Please, sign in</Typography>
            <form onSubmit={login}>
                <TextField
                    autoComplete="username"
                    variant={MATERIAL_UI_PROPS.varinats.outlined}
                    margin="normal"
                    required
                    fullWidth
                    name="name"
                    label="Login"
                    type="text"
                    size={MATERIAL_UI_PROPS.sizes.small}
                    disabled={isLoading}
                    placeholder="login"
                    value={form.name}
                    onChange={handleFormChange}
                />
                <TextField
                    autoComplete="current-password"
                    variant={MATERIAL_UI_PROPS.varinats.outlined}
                    margin="normal"
                    size={MATERIAL_UI_PROPS.sizes.small}
                    required
                    fullWidth
                    disabled={isLoading}
                    name="password"
                    label="Password"
                    type="password"
                    value={form.password}
                    onChange={handleFormChange}
                />

                <Box mt={2}>
                    {isLoading ? (
                        <CircularProgress size={24} />
                    ) : (
                        <Button
                            style={{
                                backgroundColor: vars.kpRed,
                                color: "#ffffff",
                            }}
                            type="submit"
                            variant={MATERIAL_UI_PROPS.varinats.contained}
                            disableElevation={true}
                            onClick={login}
                        >
                            Sign In
                        </Button>
                    )}
                </Box>
                <Typography
                    color={MATERIAL_UI_PROPS.colors.error}
                    variant="body1"
                >
                    {error}
                </Typography>
            </form>
        </Container>
    );
};

Unauthorized.propTypes = {
    setUser: PropTypes.func.isRequired,
};

export default Unauthorized;
